"use client";

import React from "react";
import { NodeViewWrapper } from "@tiptap/react";

interface IframeNodeFrontendProps {
  node: any;
}

export function IframeNodeFrontend({ node }: IframeNodeFrontendProps) {
  const { url } = node.attrs;

  if (!url) {
    return null;
  }

  return (
    <NodeViewWrapper className="tiptap-iframe-wrapper">
      <div className="iframe-wrapper">
        <div className="relative w-full aspect-video overflow-hidden">
          <iframe
            src={url}
            title="Embedded content"
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
            loading="lazy"
            allowFullScreen
            allow="clipboard-write"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              colorScheme: "light",
            }}
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
}
